export default __webpack_public_path__ + "static/media/problema-05.0dbe1cc5.webp";